// extracted by mini-css-extract-plugin
export default {"modalText":"financialTable_modalText__6o3Qb"};